import SessionServices from '@/services/SessionServices'
import AppConfig from '@/config/AppConfig'

import axios from 'axios'
import querystring from "querystring"
import AccountsServices from '../../services/AccountsServices';

import ComunServices from "@/services/ComunServices";
const state = {   
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken"),
    tokenType: localStorage.getItem("tokenType"),
    controlWatch: false,
    userProfile:undefined,
    userProfileSiaerp:undefined,
    userIdIAM:undefined,  
    userScopes:[],
    business_name_executive:undefined
}
const getters = {    
    accessToken: state => {
        return state.accessToken;
    },
    refreshToken: state => {
        return state.refreshToken;
    },   
    tokenType: state => {
        return state.tokenType;
    },
    controlWatch: state => {
        return state.controlWatch;
    },
    userProfile: state => {
        return state.userProfile;
    },     
    userIdIAM: state => {
        return state.userProfile;
    },    
    userScopes:state => {
        return state.userScopes;
    },    
    business_name_executive:state => {
        return state.business_name_executive;
    },
    userProfileSiaerp:state => {
        return state.userProfileSiaerp;
    },     
}
const actions = {
    getProfile(context, profileObject) {
        return new Promise((resolve) => {
            /* state.profile = profileObject;
            var date = new Date(state.profile.birth_date)
            if (date == "Invalid Date") {
                state.profile.birth_date = '';
            } */
            resolve(true);
            context.commit('disableWatch');
        });
    },
    forgotPassword(context, data) {
        let params = {
            email: data.emailUser.toLowerCase(),
        }
        var querystring = require('querystring');
        var a = 'Bearer ' + data.tokenPassword
        axios.defaults.headers.common['Authorization'] = a
        return axios.post(AppConfig.baseUrlIAM + '/auth/user/recover/request', querystring.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
    confirmaCodeRecover(context, data) {
        let params = {
            email: data.email.toLowerCase(),
            token: data.code,
        }
        var querystring = require('querystring');
        var a = 'Bearer ' + localStorage.getItem('tokenPassword')
        axios.defaults.headers.common['Authorization'] = a
        return axios.post(AppConfig.baseUrlIAM + '/auth/user/recover/validate', querystring.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
    checkEmail(context, email) {
        let params = {
            email: email.toLowerCase(),
        }
        var querystring = require('querystring');
        var a = 'Bearer ' + localStorage.getItem('tokenPassword')
        axios.defaults.headers.common['Authorization'] = a
        return axios.post(AppConfig.baseUrlIAM + '/auth/user/check-email', querystring.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
    saveNewPass(context, data) {
        let params = {
            email: data.email.toLowerCase(),
            token: data.code,
            password: data.password
        }
        var querystring = require('querystring');
        var a = 'Bearer ' + localStorage.getItem('tokenPassword')
        axios.defaults.headers.common['Authorization'] = a

        return axios.post(AppConfig.baseUrlIAM + '/auth/user/recover/password', querystring.stringify(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },
    refreshToken(context, token) {

        let axiosInstance = axios.create({
            timeout: 6000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        });
        return axiosInstance.post(AppConfig.baseUrlIAM + '/iam/oauth/authenticate')
    },

    login(context, payload) {
        localStorage.clear();
        return SessionServices.login(payload.username, payload.password)
            .then((res) => {
                if (res.data.code == 200) {
                    localStorage.setItem("accessToken", res.data.data.accessToken);
                    localStorage.setItem("refreshToken", res.data.data.refreshToken);
                    
                    let expirationTime = new Date(res.data.data.accessTokenExpiresAt);
                    let expirationRefreshTime = new Date(res.data.data.refreshTokenExpiresAt);
                    localStorage.setItem("expirationTime", expirationTime.getTime())
                    localStorage.setItem("expirationRefreshTime", expirationRefreshTime.getTime())                    
                    
                    AccountsServices.getProfileIAM(res.data.data.accessToken)
                        .then((responseProfile) => {
                            if (!responseProfile.data.data.profile.photoUrl) {
                                responseProfile.data.data.profile.photoUrl = "/static/avatars/user-13.jpg";
                            }                         
                            //Storing user profile
                            context.commit("mSetUserProfile", responseProfile.data.data.profile);              
                            //Storing user id IAM
                            context.commit("mSetUserIdIAM",res.data.data.userId);
                            //Storing user scopes
                            context.commit("mSetUserScopes",responseProfile.data.data.scope);
                            
                            
                            SessionServices.getInfoUserById(responseProfile.data.data.profile.user_id).then((dataUserSiaerp=>{

                                context.commit("mSetUserSiaerp",dataUserSiaerp.data);
                            }))

                            context.dispatch("getProfile", responseProfile.data.data.profile);

                            
                            const profile =  responseProfile.data.data.profile;
                            const scope = responseProfile.data.data.scope;

                            if(scope.includes("aps_executive") || scope.includes("aps_promotor")){
                                ComunServices.getExternalAgents(profile.aps).then(response => {
                                    //localStorage.setItem("business_name", response.data.data.Nombre)
                                    context.commit("mSetBusinessNameExecutive",response.data.data.Nombre);
                           })
                            }                            
                        })
                }
                return res;
            })
    },
    loginWeb(context, data) {        
        localStorage.setItem("accessToken", data.access);
        localStorage.setItem("refreshToken", data.refresh);        
        localStorage.setItem("expirationTime", data.expiredTime)
        localStorage.setItem("expirationRefreshTime", data.expiredRefreshTime)

        return AccountsServices.getProfileIAM(data.access).then((responseProfile) => {
            if (!responseProfile.data.data.profile.photoUrl) {
                responseProfile.data.data.profile.photoUrl = "/static/avatars/user-13.jpg";
            }
            context.commit("mSetUserProfile", responseProfile.data.data.profile);
            context.commit("mSetUserIdIAM",responseProfile.data.data.profile.uid);
            //Storing user scopes
            context.commit("mSetUserScopes",responseProfile.data.data.scope);
            let profile = responseProfile.data.data.profile
            const scope = responseProfile.data.data.scope;
            if(scope.includes("aps_executive") || scope.includes("aps_promotor")){
                ComunServices.getExternalAgents(profile.aps).then(response => {
                    //localStorage.setItem("business_name", response.data.data.Nombre)
                    context.commit("mSetBusinessNameExecutive",response.data.data.Nombre);
                })
            } 
            return responseProfile
        })
    },
    generateToken(context, payload) {
        return SessionServices.generateToken(payload)

    },
    generateTokenPassword(context, payload) {
        return SessionServices.generateTokenPassword()
            .then((res) => {
                localStorage.setItem("tokenPassword", res.data.data.accessToken);
            });
    },

    logoutUser(context) {
        var a = 'Bearer ' + localStorage.getItem('accessToken')
        axios.defaults.headers.common['Authorization'] = a       
        return axios.post(AppConfig.baseUrlIAM + '/iam/oauth/logout')
            .then(() => {
                context.commit("mLogOutProfile")
                localStorage.clear();
            })
    },
    updateAccount(context, account) {
        return AccountsServices.updateAccountIAM(account).then((res) => {  
            context.commit("mSetUserProfile", res.data.data.profile);
            //Storing user scopes
            context.commit("mSetUserScopes",res.data.data.scope);
            return res;
        });
    },
    updatePasswordAccountIAM(context, account) {
        return AccountsServices.updatePasswordAccountIAM(account)

    },
 
    doSetUserProfile(context){
        return new Promise((resolve,reject)=>{
            if(localStorage.getItem("accessToken")){  
            AccountsServices.getProfileIAM(localStorage.getItem("accessToken"))
            .then((responseProfile) => {                 
                if(responseProfile.data.code==200){
                if (!responseProfile.data.data.profile.photoUrl) {
                    responseProfile.data.data.profile.photoUrl = "/static/avatars/user-13.jpg";
                }             
                context.commit("mSetUserProfile", responseProfile.data.data.profile);
                context.commit("mSetUserScopes", responseProfile.data.data.scope);                
                }
                resolve();
            }).catch(reject)
        }else{
            resolve();
        }
        });       
    }
}
const mutations = {
    
    mSetBusinessNameExecutive(state,data) {
        state.business_name_executive = data;
    },
    enableWatch(state) {
        state.controlWatch = true;

    },
    disableWatch(state) {
        state.controlWatch = false;
    },
    mSetUserProfile(state,data){    
        const date = new Date(data.birth_date)
        if (date == "Invalid Date") {
            data.birth_date = '';
        }   
        state.userProfile = data;
    },
    mLogOutProfile(state){          
        state.userProfile = undefined;
        state.business_name_executive= undefined
    },
    mSetUserIdIAM(state,data){
        state.userIdIAM = data;
    },
    mSetUserScopes(state,data){
        state.userScopes = data;
        
    },
    mSetUserSiaerp(state,data){
        state.userProfile = data;
        
    },
    mSetUserSiaerpByEmail(state,data){
        state.userProfileSiaerp = data;
        
    },

}
export default {
    state,
    getters,
    actions,
    mutations
}